import React from 'react';
import { useFormContext, ValidationIndicator, FieldHintAndError } from '@/components/form';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

const FormInput = ({
  name = "_",
  label,
  type = 'text',
  validators,
  required = false,
  placeholder,
  hint,
  className,
  disabled = false
}) => {

  const form = useFormContext();

  const requiredValidator = ({ value }) => {
    if (required && (!value || value.toString().trim() === '')) {
      return 'This field is required';
    }

    if (validators) {
      return validators({ value });
    }

    return undefined;
  };

  const finalValidators = validators ? validators : { onBlur: requiredValidator };

  return (
    <form.Field
      name={name}
      validators={finalValidators}
    >
      {(field) => {
        const hasError = field.state.meta.isTouched && field.state.meta.errors.length > 0;
        const hasAsyncValidationIndicator = !!(
          field.options.validators?.onChangeAsync ||
          field.options.validators?.onBlurAsync ||
          field.options.validators?.onSubmitAsync
        );


        return (
          <div className={cn("space-y-2", className)}>
            <Label
              htmlFor={field.name}
              className={hasError ? 'text-destructive' : ''}
            >
              {label}
              {(required || validators) && (
                <span className={hasError ? 'text-destructive' : 'text-muted-foreground'}>
                  {' *'}
                </span>
              )}
            </Label>
            <div className="relative">
              <Input
                id={field.name}
                type={type}
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
                onBlur={field.handleBlur}
                placeholder={placeholder}
                disabled={disabled}
                className={cn(
                  hasError ? 'border-destructive focus:ring-destructive' : '',
                  hasAsyncValidationIndicator ? 'pl-3 pr-10 truncate' : ''
                )}
              />
              <ValidationIndicator field={field} />
            </div>
            <FieldHintAndError field={field} hint={hint} />
          </div>
        );
      }}
    </form.Field>
  );
};

export default FormInput;
export { FormInput };
